import {useState} from "react";
import { MdArrowDropUp, MdArrowDropDown } from "react-icons/md";

const PredictionCard = ({ element, openPrediction = false, btnElements = null, title }) => {
  const [openPred, setOpenPred] = useState(openPrediction);

  return (
    <div
      className="free_bet_container"
      style={{
        borderRadius: ".5rem",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        //   padding: "0.5rem 0",
          width: "100%",
          color: "white",
          cursor: "pointer",
        }}
        onClick={() => setOpenPred((prev) => !prev)}
      >
        <span
          style={{
            color: "white",
            padding: "0.5rem 1rem",
            border: "none",
            fontWeight: "bold",
            fontSize: "1rem",
          }}
        >
          {" "}
          {title ? title : " "}
        </span>

        {openPred ? <MdArrowDropUp size={30} /> : <MdArrowDropDown size={30} />}
      </div>
      {openPred && (
        <div className="bet_list_container">
          <table className="free_daily_bet">
            <thead>
              <tr>
                <th></th>
                {/* <th>League</th> */}
                <th>Team</th>
                <th>Tips</th>
                <th>Time</th>
                <th>Results</th>
              </tr>
            </thead>

            <tbody>{element}</tbody>
          </table>

          {btnElements && <div className="ref_btn_container">{btnElements}</div>}
        </div>
      )}
    </div>
  );
};

export default PredictionCard;
